export const DYNAMIC_BOOKING_REQUESTED = 'DYNAMIC_BOOKING_REQUESTED' as const;
export const DYNAMIC_BOOKING_ACKED = 'DYNAMIC_BOOKING_ACKED' as const;
export const DYNAMIC_BOOKING_REQUEST_FAILED = 'DYNAMIC_BOOKING_REQUEST_FAILED' as const;
export const DYNAMIC_ALL_BOOKING_RESULTS_RECEIVED = 'DYNAMIC_ALL_BOOKING_RESULTS_RECEIVED' as const;
export const DYNAMIC_BOOKING_TRADE_DONE = 'DYNAMIC_BOOKING_TRADE_DONE' as const;
export const DYNAMIC_BOOKING_TRADE_REJECTED = 'DYNAMIC_BOOKING_TRADE_REJECTED' as const;
export const DYNAMIC_BOOKING_QUOTE_FAILED = 'DYNAMIC_BOOKING_QUOTE_FAILED' as const;
export const DYNAMIC_BOOKING_TRADE_AUTH_FAILED = 'DYNAMIC_BOOKING_TRADE_AUTH_FAILED' as const;
